export const servicesTranslations = {
  es: {
    portfolio: {
      title: "Portafolio de",
      subtitle: "Soluciones SaMD",
      description: "Seleccionamos rigurosamente las arquitecturas algorítmicas más sólidas a nivel global para resolver desafíos clínicos específicos.",
      activeSolutions: "Soluciones Activas",
      details: "Solicitar Detalle",
      viewAll: "Ver Todas las Soluciones",
      sovereignty: {
        title: "Arquitecturamos su Soberanía",
        subtitle: "Agnóstico",
        text: "Nuestra ventaja no está en una marca, sino en nuestra capacidad de integración agnóstica. Si el día de mañana surge un algoritmo superior, su infraestructura estará lista para el cambio sin costos de salida.",
        guarantee: "Garantía Vendor-Neutral"
      }
    }
  },
  en: {
    portfolio: {
      title: "Portfolio of",
      subtitle: "SaMD Solutions",
      description: "We rigorously select the most solid algorithmic architectures globally to solve specific clinical challenges.",
      activeSolutions: "Active Solutions",
      details: "Request Details",
      viewAll: "View All Solutions",
      sovereignty: {
        title: "Architecting Your Sovereignty",
        subtitle: "Agnostic",
        text: "Our advantage is not in a brand, but in our agnostic integration capacity. If a superior algorithm emerges tomorrow, your infrastructure will be ready for change without exit costs.",
        guarantee: "Vendor-Neutral Guarantee"
      }
    }
  }
};
